window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.sortable = require('jquery-ui/ui/widgets/sortable')
    require('bootstrap');
    window.moment = require('moment');
    let Chart = require('chart.js');
    require('bootstrap-datepicker');
    require('bootstrap-select');
    require('../../../compass-side-panels/resources/js/side-panels');
    require('../../../compass-tables/resources/js/app');
    require('../../../compass-forms/resources/js/app');

} catch (e) {console.log(e)}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

window.bootstrapDatepickerConfig ??= {
    dateFormat: 'dd-mm-yy',
    weekStart: 1,
    ignoreReadonly: true,
    orientation: 'auto',
    forceParse: false,
    language: document.getElementsByTagName('html')[0].getAttribute('lang'),
    format: {
        /*
         * Say our UI should display a week ahead,
         * but textbox should store the actual date.
         * This is useful if we need UI to select local dates,
         * but store in UTC
         */
        toDisplay: function (date, format, language) {
            return moment(date).format('DD-MM-YYYY');
        },
        toValue: function (date, format, language) {
            return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
        }
    }
}

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-tooltip]').tooltip()
    // todo, fix below
    // require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min.js')
    // require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min.js')
    $('.datepicker').datepicker(bootstrapDatepickerConfig);
})
